import React, { useState, useEffect, useCallback, useMemo } from "react";
import styles from "./UserManagement.module.css";
import { CustomPagination, CustomTable } from "../../components";
import { AxiosInstance } from "../../services/Api";
import { CSVLink } from "react-csv";

const RequestDemo = () => {
  const [demoRequests, setDemoRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const fetchDemoRequests = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get("/roll/demo-requests");

      if (response.data?.success && response.data.data) {
        setDemoRequests(response.data.data.demolist);
      } else {
        setDemoRequests([]);
        throw new Error(
          response.data?.message || "Failed to fetch demo requests"
        );
      }
    } catch (err) {
      console.error("Error fetching demo requests:", err);
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDemoRequests();
  }, [fetchDemoRequests]);

  const paginatedRequests = useMemo(() => {
    const start = (page - 1) * limit;
    const data = Array.isArray(demoRequests) ? demoRequests : [];
    return data.slice(start, start + limit);
  }, [demoRequests, page, limit]);

  const columns = useMemo(
    () => [
      { key: "id", label: "ID", width: "80px" },
      {
        key: "first_name",
        label: "NAME",
        minWidth: "180px",
        // render: (_, row) =>
        //   [row.first_name, row.middle_name, row.last_name]
        //     .filter(Boolean)
        //     .join(" "),
      },
      { key: "email", label: "EMAIL", minWidth: "250px" },
      { key: "designation", label: "DESIGNATION", minWidth: "150px" },
      { key: "institution_name", label: "INSTITUTION", minWidth: "200px" },
      { key: "message", label: "MESSAGE", minWidth: "300px" },
    ],
    []
  );

  const handleRowClick = (row) => {
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <h1 className={styles.title}>REQUEST DEMO</h1>
        <div className={styles.headerActions}>
          <button
            type="button"
            className={styles.menuButton}
            aria-label="More options"
            title="Download CSV"
          >
            <CSVLink
              data={demoRequests}
              filename={"REQUEST_DEMO_LIST.csv"}
              className={styles.menuButton}
              aria-label="Download CSV"
            >
              <i
                className="fa-solid fa-download"
                style={{ fontSize: "18px", color: "#333" }}
              ></i>
            </CSVLink>
          </button>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className={styles.errorMessage}>
          {error}
          <button onClick={fetchDemoRequests} className={styles.retryButton}>
            Retry
          </button>
        </div>
      )}

      {/* Table */}
      <div className={styles.tableSection}>
        <CustomTable
          columns={columns}
          rows={paginatedRequests}
          onRowClick={handleRowClick}
          loading={loading}
          emptyMessage="No demo requests found"
          hoverable
          rowKeyField="id"
        />
      </div>

      {/* Pagination */}
      <div className={styles.paginationSection}>
        <CustomPagination
          page={page}
          limit={limit}
          total={demoRequests.length}
          onPageChange={handlePageChange}
          showLimitSelector={false}
          siblingCount={3}
          showFirstLast
          showPrevNext
        />
      </div>
    </div>
  );
};

export default RequestDemo;
